import $ from 'jquery';

import Format from 'helpers/format';
import Monitoring from 'shared_modules/Monitoring';

const MultiCurrencyFieldBaseStatic = (): MultiCurrencyFieldBaseStatic => {
  const replaceCurrencySymbol = ({
    currencyCodes = [],
    currencySymbols = [],
    targetSelector,
  }: MultiCurrencyReplaceCurrencySymbolInput) => {
    const targetField = $(targetSelector);
    const currencyCodesLength = currencyCodes.length;
    const currencySymbolsLength = currencySymbols.length;

    const locale = window.merchantos.multiCurrency.getLocale();
    const systemCurrencySymbol = window.merchantos.multiCurrency.getSystemCurrencySymbol();

    try {
      if (!targetField.length) {
        throw new Error(`${targetSelector} element does not exist.`);
      }

      if (!currencyCodesLength && !currencySymbolsLength) {
        throw new Error(`${targetSelector} has missing currency data.`);
      }

      if (currencyCodesLength) {
        const isSingle = currencyCodesLength === 1;

        if (!isSingle && currencyCodesLength !== targetField.length) {
          throw new Error(`${targetSelector} has mismatching currency codes.`);
        }

        targetField.each((index, field) => {
          const fieldEl = $(field);
          const currencyIndex = isSingle ? 0 : index;
          const currencyCode = currencyCodes[currencyIndex];
          const currencySymbol = window.merchantos.multiCurrency.getCurrencySymbol({
            currencyCode,
          });
          const fieldValue = fieldEl
            .text()
            .replace(currencySymbol, '')
            .replace(systemCurrencySymbol, '');

          fieldEl.text(Format.toMoney(fieldValue, currencyCode, locale));
        });

        return;
      }

      if (currencySymbolsLength) {
        const isSingle = currencySymbolsLength === 1;

        if (!isSingle && currencySymbolsLength !== targetField.length) {
          throw new Error(`${targetSelector} has mismatching currency symbols.`);
        }

        targetField.each((index, field) => {
          const fieldEl = $(field);
          const symbolIndex = isSingle ? 0 : index;

          fieldEl.text(fieldEl.text().replace(systemCurrencySymbol, currencySymbols[symbolIndex]));
        });
      }
    } catch (error) {
      Monitoring.addError(error, 'MultiCurrencyFieldBaseStatic', {
        currencyCodes,
        currencySymbols,
        locale,
        targetSelector,
      });
    }
  };

  return {
    replaceCurrencySymbol,
  };
};

export default MultiCurrencyFieldBaseStatic;
